import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


export const ROUTES: Routes = [
  { path: '', redirectTo: '/request-list', pathMatch: 'full' },
  { path: '**', redirectTo: '/request-list' }
];


@NgModule({
  providers: [],
  imports: [ RouterModule.forRoot(ROUTES, { useHash: true }) ],
  exports: [ RouterModule ],
})
export class AppRoutingModule {}
